import Newquery from "./newquery";

export default Newquery;
